import { useQsFilters } from "@dash/filters";

import { Serializers, SerializerValue } from "@megaron/serializers";

export const cartsFiltersSerializer = Serializers.object({
  page: Serializers.integer.optional(),
  isArchived: Serializers.boolean.optional(),
  hasRewards: Serializers.boolean.optional(),
  excludeEmpty: Serializers.boolean.optional(),
  searchTerm: Serializers.string.optional(),
}).partial();

export type CartsFiltersType = SerializerValue<typeof cartsFiltersSerializer>;

export const useCartsFilters = () => {
  const defaultFilters: CartsFiltersType = {
    page: 0,
    isArchived: false,
    hasRewards: undefined,
    excludeEmpty: true,
  };

  const { filters, setFilters } = useQsFilters(cartsFiltersSerializer, defaultFilters);

  const setFilter =
    <K extends keyof CartsFiltersType>(key: K) =>
    (value: CartsFiltersType[K]) =>
      setFilters({ ...filters, [key]: value });

  return { filters, setFilter, setFilters, defaultFilters };
};
